<template>
  <BaseAction>
    <div class="d-flex justify-center">
      <SecondaryButton @click.native="openDialog" color="primary">
        <inline-svg :src="require('@/assets/svg/thumb_up.svg')" width="25" />
        Approve Offer
      </SecondaryButton>
      <ApproveOfferDialog v-if="isOpen" @close="closeDialog" />
    </div>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import ApproveOfferDialog from "@/views/offers/dialogs/ApproveOfferDialog";
import BaseAction from "@/components/common/BaseAction";
import InlineSvg from "vue-inline-svg";

export default {
  name: "ApproveOfferAction",
  components: {
    SecondaryButton,
    ApproveOfferDialog,
    BaseAction,
    InlineSvg
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
